import * as fromActions from '../actions/questions.action'
import * as fromEvaluation from '../actions/evaluation-questions.action'
import { Reducer } from 'redux'

export const initialState: any = {
  list: [],
  edit: [],
  loading: false,
}

export const reducer: Reducer = (
  state: any = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.GET_QUESTION_LIST_SUCCESS:
      return {
        ...state,
        list: payload,
        loading: false,
      }
    case fromActions.GET_QUESTIONS_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.SET_QUESTION_LOADING:
      return {
        ...state,
        loading: payload,
      }
    case fromActions.QUESTION_LIKERT_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.QUESTION_OPENENDED_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.QUESTION_OPENENDED_DESTROY:
      return {
        ...state,
        loading: true,
      }
    case fromActions.QUESTION_LIKERT_DESTROY:
      return {
        ...state,
        loading: true,
      }
    case fromActions.QUESTION_OPENENDED_EDIT:
      return {
        ...state,
        loading: true,
      }
    case fromActions.QUESTION_LIKERT_EDIT:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_QUESTION_SUCCESS:
      return {
        ...state,
        edit: payload,
      }
    case fromEvaluation.EVALUATION_QUESTION_LIKERT_CREATE:
      return {
        ...state,
        loading: true,
      }
    case fromEvaluation.EVALUATION_QUESTION_LIKERT_DESTROY:
      return {
        ...state,
        loading: true,
      }
    case fromEvaluation.EVALUATION_QUESTION_LIKERT_EDIT:
      return {
        ...state,
        loading: true,
      }
    case fromEvaluation.GET_EVALUATION_QUESTION_SUCCESS:
      return {
        ...state,
        edit: payload,
      }
    default:
      return state
  }
}
